// @flow
import { getAuthToken, getBidderId, LOG_OUT_BIDDER } from './user';
import api from '../api/recommended';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import ms from 'ms';
// $FlowFixMe
import { REHYDRATE } from 'redux-persist/constants';

/* Action Types */
export const LOAD_RECOMMENDED_ITEMS_FAIL = 'la/domain/recommendedItem/LOAD_FAIL';
export const LOAD_RECOMMENDED_ITEMS_REQUEST = 'la/domain/recommendedItem/LOAD_REQUEST';
export const LOAD_RECOMMENDED_ITEMS_SUCCESS = 'la/domain/recommendedItem/LOAD_SUCCESS';

const REDUX_STORE_TIME = ms('30m');

/* reducer */
const DEFAULT_STATE = {
    byId: {},
    loaded: 0,
    loading: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let existing;
    let time;

    switch (action.type) {
        case REHYDRATE:
            if (Object.prototype.hasOwnProperty.call(action.payload, 'recommendedItem')) {
                const incoming = action.payload.recommendedItem;
                return { ...state, ...incoming };
            }
            return state;
        case LOAD_RECOMMENDED_ITEMS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case LOAD_RECOMMENDED_ITEMS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_RECOMMENDED_ITEMS_SUCCESS:
            existing = cloneDeep(state.byId);
            time = action.meta.actionTime;

            if (action.payload) {
                action.payload.forEach(x => {
                    existing[x.itemId] = { ...x };
                });
            }

            return {
                ...state,
                byId: existing,
                loaded: time,
                loading: false,
            };
        case LOG_OUT_BIDDER:
            return {
                ...DEFAULT_STATE,
            };

        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.recommendedItem;

const byIdSelector = createSelector(stateSelector, state => state.byId);

const getLoadTimeForRecommendedItem = createSelector(stateSelector, state => state.loaded);

const isRecommendedItemLoading = createSelector(stateSelector, state => state.loading);

export const getSortedRecommendedItemIdsFromState = createSelector(byIdSelector, byId => {
    const toBeSorted = Object.keys(byId).map(item => byId[item]);
    const sorted = toBeSorted.sort((a, b) => b.timestamp - a.timestamp);
    return sorted.map(item => item.itemId);
});

const shouldFetchRecommendedItem = createSelector(
    [getLoadTimeForRecommendedItem, isRecommendedItemLoading],
    (loaded, loading) => {
        const time = Date.now();
        const diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
        return !loading;
    }
);

/* ACTION CREATORS */
const fetchRecommendedItem = amazon => async (dispatch, getState) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);
        dispatch({
            type: LOAD_RECOMMENDED_ITEMS_REQUEST,
        });
        const response = await api.fetchRecommendedItem({ amazon, authToken, bidderId, deployment });
        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: LOAD_RECOMMENDED_ITEMS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOAD_RECOMMENDED_ITEMS_FAIL,
        });
    }
};

export const fetchRecommendedItemIfNeeded = (amazon: boolean) => async (dispatch: Function, getState: Function) => {
    const needed = shouldFetchRecommendedItem(getState());
    if (needed || amazon) {
        return dispatch(fetchRecommendedItem(amazon));
    }
    return Promise.resolve();
};
